// Срез списка: что вообще показываем — активное, архив, скрытое в deal или всё
// вместе. Не тумблеры-«добавки»: «Архивные» показывают только архив, «Скрытые» —
// только скрытое. Словарь общий на справочник компаний и на проекты компании.

export const LIST_SLICES = ['active', 'archived', 'hidden', 'all'] as const
export type ListSlice = (typeof LIST_SLICES)[number]

export const LIST_SLICE_LABELS: Record<ListSlice, string> = {
  active: 'Активные',
  archived: 'Архивные',
  hidden: 'Скрытые',
  all: 'Все',
}

export const listSliceOptions = LIST_SLICES.map((value) => ({
  value,
  label: LIST_SLICE_LABELS[value],
}))

export function parseListSlice(value: unknown): ListSlice | undefined {
  return LIST_SLICES.find((s) => s === value)
}

/**
 * Флаги серверной выборки под срез: «активные» — узкий набор по умолчанию,
 * остальные срезы считаются из полного (скрытое и архивное сервер иначе не
 * отдаёт).
 */
export function listSliceFilters(slice: ListSlice): {
  includeHidden: boolean
  includeArchived: boolean
} {
  const wide = slice !== 'active'
  return { includeHidden: wide, includeArchived: wide }
}

/**
 * Отбор строк полного набора под срез: архив — по флагу самой строки, скрытое —
 * разницей с видимым набором (флага видимости строки списков не несут).
 */
export function bySlice<T extends { archived?: boolean }>(
  rows: T[],
  slice: ListSlice,
  isHidden: (row: T) => boolean,
): T[] {
  switch (slice) {
    case 'archived':
      return rows.filter((row) => row.archived === true)
    case 'hidden':
      return rows.filter((row) => isHidden(row))
    default:
      return rows
  }
}
